//@flow
import { type State } from "../../state";
import type { ArquivoMedida, OperacaoArquivos } from "../../model";

export const isAbrindoArquivo = (state: State): boolean =>
  Boolean(state.arquivosMedidas.carregandoArquivo);

export const getOperacaoArquivos = (state: State): ?OperacaoArquivos =>
  state.arquivosMedidas.operacao;

export const getExtraInfoOperacaoArquivos = (state: State): any =>
  state.arquivosMedidas.extraInfoOperacao;

export const getArquivoEmCache = (state: State): ?ArquivoMedida =>
  state.arquivosMedidas.arquivoEmCache;

export const getNomeArquivoEmCache = (state: State): ?string => {
  const arquivoEmCache: ?ArquivoMedida = getArquivoEmCache(state);
  return arquivoEmCache && arquivoEmCache.nome;
};

export const salvandoArquivo = (state: State): boolean =>
  state.arquivosMedidas.salvandoArquivo;

export const permiteCompartilhamentoDeArquivo = (state: State) =>
  state.arquivosMedidas.permiteCompartilhamento;
